


































































/* Created- 11 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaError from "@/Ui-Components/Common/Error/ParticaError.vue";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ParticaFullDialog from "@/Ui-Components/Common/Container/ParticaFullDialog.vue";
import ParticaCardDialog from "@/Ui-Components/Common/Container/ParticaDialogCard.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaIssueBase from "../../Base/ParticaIssueBase.vue";
import { ParticaEvent, eParticaAction, getActionName } from "../../../Models/ParticaEvent";
import { ParticaDropEvent, eParticaDragType, ParticaItem, ParticaSubItem } from "../../../Models/ParticaItem";
import { MyGroupingOfArticlePropDTO, IIssueModel, IssueModel } from "../../../Generated/ParticaAPI";
import ParticaArticleMetadata from "@/Ui-Components/Article/Metadata/ParticaMetadata.vue";
import { Article, IArticle, IExtractedArticle, IMetadataArticle } from "../../../Models/ArticleModels/article";
import { ButtonConfig, ButtonType, ButtonStatus } from "../../../Models/Buttons";
import ParticaConfirmDialog from "@/Ui-Components/Common/ConfirmDialog/ParticaConfirmDialog.vue";
import { ParticaConfirmConfig } from "../../../Models/Components.model";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import { IIssueService } from "../../../BusinessServices/issue";
import SectionManager from "@/Views/Domain/Title/SectionManager.vue";
import { IMetadataService } from "../../../BusinessServices/metadataarticles";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
import ParticaTree from "@/Ui-Components/Common/Tree/ParticaTree.vue";

@Component(
	{
		name: "IssueManageMetadata",
		components: {
			ParticaError,
			ParticaRowContainer,
			ParticaFullDialog,
			ParticaArticleMetadata,
			ParticaConfirmDialog,
			ButtonList,
			SectionManager,
			ParticaCard,
			ParticaView,
			ParticaCardDialog,
			ParticaRightDrawer,
			ParticaTree
		}
	})
export default class IssueManageMetadata extends ParticaIssueBase {
	@Prop() private id: number;
	private metadataService: IMetadataService;
	private articles: ParticaItem[] = [];
	private showsectionmanager: boolean = false;
	private issue: IssueModel = new IssueModel();
	private issueService: IIssueService;

	private buttons: ButtonConfig[] = [
		{
			label: "Section Manager",
			action: eParticaAction.PUBLICATION_SECTION_MANAGER,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Create Table of Contents",
			action: eParticaAction.ISSUE_TOC,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
	];


	private editarticle: IMetadataArticle = new Article() as IMetadataArticle;
	private showedit: boolean = false;
	private editbuttons: ButtonConfig[] = [
		{
			label: "Save",
			action: eParticaAction.ARTICLE_SAVE,
			type: ButtonType.OK,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
		{
			label: "Delete",
			action: eParticaAction.ARTICLE_DELETE_REQUEST,
			type: ButtonType.Cancel,
			status: ButtonStatus.Enabled
		} as ButtonConfig,
	];

	@Watch("showsectionmanager")
	private async reloadsections() {
		if (this.showsectionmanager === false) {
			await this.init();
		}
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.PROPERTY_CHANGED: {
					break;
				}
				case eParticaAction.ISSUE_TOC: {
					this.navigate("issuetoc", { id: this.id.toString() });
					break;
				}
				case eParticaAction.LEFT_MOUSE_CLICK:
				case eParticaAction.RIGHT_MOUSE_CLICK: {
					this.editarticle = await this.metadataService.getArticle(this.id, event.item.id as string);
					this.showedit = true;
					break;
				}
				case eParticaAction.ARTICLE_SAVE: {
					this.editarticle = await this.metadataService.saveArticle(this.editarticle);
					this.init();
					break;
				}
				case eParticaAction.ARTICLE_DELETE_REQUEST: {
					this.dialog.title = "Confirm deletion of metadata.";
					this.dialog.message = `You have requested that '${event.item.title}' be deleted.`;
					this.dialog.action = eParticaAction.ARTICLE_DELETE;
					this.dialog.show = true;
					this.dialog.item = event.item;
					break;
				}
				case eParticaAction.ARTICLE_DELETE: {
					this.dialog.show = false;
					const todelete = await this.metadataService.getArticle(this.id, event.item.articleId as string);
					await this.metadataService.deleteArticle(todelete);
					await this.init();
					break;
				}
				case eParticaAction.PUBLICATION_SECTION_MANAGER: {
					this.showsectionmanager = true;
					break;
				}
				case eParticaAction.DRAG_MOVE_REQUEST: {
					const movedata: ParticaDropEvent = event.item as ParticaDropEvent;
					switch (movedata.dragtype) {
						case eParticaDragType.one: {
							this.dialog.title = "Confirm moving metadata.";
							this.dialog.message = `Move metadata '${movedata.source.name}' to section '${movedata.destination.name}'?`;
							this.dialog.action = eParticaAction.DRAG_MOVE;
							this.dialog.item = movedata;
							this.dialog.show = true;
							break;
						}
						case eParticaDragType.many: {
							this.dialog.title = "Confirm moving metadata.";
							this.dialog.message = `Move all metadatafrom section '${movedata.source.name}' to section '${movedata.destination.name}'?`;
							this.dialog.action = eParticaAction.DRAG_MOVE;
							this.dialog.item = movedata;
							this.dialog.show = true;
							break;
						}
						case eParticaDragType.all: {
							// check issue is not dropped on itself.
							// confirm you want to move all articles in issue to new issue.
							// if different pub then sections will be created if they do not exist.
							this.ShowSnackbar(`not implemented`);
							break;
						}
					}
					break;
				}
				case eParticaAction.DRAG_MOVE: {
					const movedata: ParticaDropEvent = event.item as ParticaDropEvent;
					switch (movedata.dragtype) {
						case eParticaDragType.one: {
							this.dialog.show = false;
							await this.metadataService.moveArticle(movedata.source.id, parseInt(movedata.destination.id, 0), this.id);
							await this.init();
							break;
						}
						case eParticaDragType.many: {
							this.dialog.show = false;
							const section: ParticaItem | undefined = this.articles.find(a => a.id === movedata.source.id);
							if (section !== undefined) {
								const articleIds: string[] = section.items.map(i => i.id);
								await this.metadataService.moveArticles(articleIds, parseInt(movedata.destination.id, 0), this.id);
							}
							await this.init();
							break;
						}
						case eParticaDragType.all: {
							// this.ShowSnackbar(`confirm move many ${movedata.source.name} to ${movedata.destination.name}`)
							break;
						}
					}
					break;
				}

				default: {
					this.baseEventHandler(event);
				}
			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadataService = this.particaServices.getMetadataService();
		this.issueService = this.particaServices.getIssueService();
		this.metadata.name = "Manage Metadata";
		await this.init();
		await this.getIssueNav(this.id);
	}

	private async init() {
		try {
			this.LoadingStart();
			// get articles by section
			this.issue = await this.issueService.getIssue(this.id);
			this.articles = await this.metadataService.getArticlesBySection(this.id);
			this.articles.forEach(article => {
				article.children = article.items;
			});
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}


}
